<template>
  <div id="projectApproval">
		<el-card :class="detailShow? 'hiddencard' : ''">
			<el-form :model="searchForm" ref="searchForm" label-width="180px">
				<el-row>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Project Name:" prop="majorProjectName">
							<el-input clearable v-model="searchForm.majorProjectName" placeholder="Please input" />
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Major Project Type:" prop="majorProjectType">
							<el-select clearable v-model="searchForm.majorProjectType" placeholder="Please select">
								<el-option
									v-for="item in majorProjectType"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Major Project Category:" prop="majorProjectCategoryList">
							<el-select multiple clearable v-model="searchForm.majorProjectCategoryList" placeholder="Please select">
								<el-option
									v-for="item in majorProjectCategory"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Application Status:" prop="approvalStatus">
							<el-select clearable v-model="searchForm.approvalStatus" placeholder="Please select">
								<el-option
									v-for="item in applyStatus"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="3S2S:" prop="is3S2S">
							<el-select clearable v-model="searchForm.is3S2S" placeholder="Please select">
								<el-option
                  v-for="item in yesOrNo"
                  :key="item.labelKey"
                  :label="item.labelValue"
                  :value="item.labelKey"
                >
                </el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="18" :lg="8" :md="12" style="padding: 10px 0 0 20px; text-align: right;">
						<el-button type="primary" size="small" @click="handleSearch()">Search</el-button>
						<el-button size="small" @click="handleReset()">Reset</el-button>
					</el-col>
				</el-row>
			</el-form>
			<el-table :data="tableData" border v-loading="tableLoading" style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
        <el-table-column prop="id" label="id" v-if="false" ></el-table-column>
        <el-table-column prop="majorProjectName" label="Project Name" align="center" min-width="150" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<a style="color:blue;" @click="openDetail(scope.row)">{{ scope.row.majorProjectName }}</a>
					</template>
				</el-table-column>
				<el-table-column prop="majorProjectLevelDesc" label="Major Project Level" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
				<el-table-column prop="majorProjectTypeDesc" label="Major Project Type" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
				<el-table-column prop="majorProjectCategoryDesc" label="Major Project Category" align="center" min-width="130" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="submitter" label="Applicant" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="submissionTime" label="Applicantion Time" align="center" min-width="110" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="department" label="Department" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="lastProcessor" label="Approver" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="lastProcessedTime" label="Approver Time" align="center" min-width="110" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="approvalStatusDesc" label="Application Status" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="operation" label="Operation" align="center" min-width="100">
					<template slot-scope="scope">
						<el-button size="mini" type="danger" @click="openDiscard(scope.row)" v-if="scope.row.approvalStatus === 3 ">Discard</el-button>
					</template>
				</el-table-column>
      </el-table>
			<div class="pageDiv" v-if="totalCount && totalCount > 0">
				<el-pagination
					small
					layout="total, prev, pager, next, sizes, jumper"
					:page-sizes="[10, 20, 50, 100]"
					:current-page="currentPage"
					:page-size="pageSize"
					:total="totalCount"
					@size-change="changePageSize"
					@current-change="changePage"
				>
				</el-pagination>
			</div>
		</el-card>
		<el-dialog
			title="Discard"
			width="500px"
			:visible.sync="discardVisible"
			:close-on-click-modal="false"
		>
			<el-form :model="discardForm" ref="discardForm" label-width="0">
				<el-form-item label="" prop="reason" :rules="[{ required: true, message: 'Please input' }]">
					<el-input type="textarea" :rows="4" v-model="discardForm.reason" placeholder="Please input reason" />
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeDiscard()">Cancel</el-button>
				<el-button type="primary" :loading="discardLoading" size="small" @click="projectDiscard()">Confirm</el-button>
			</span>
		</el-dialog>
		<detail v-if="detailShow" :id="detailId" page="projectApproval" @closeDetail="closeDetail" />
  </div>
</template>
<script>
	import detail from '../projectApplication/index.vue'
  export default {
    name: 'projectApproval',
		components: {
			detail
		},
    created () {
			this.getSelectInfo()
			this.handleSearch()
    },
    data () {
      return {
				majorProjectType: [],
				majorProjectCategory: [],
				majorProjectLevel: [],
				applyStatus: [],
				yesOrNo: [
					{ labelKey: true, labelValue: 'Yes' },
					{ labelKey: false, labelValue: 'No' }
				],
        searchForm: {},
				tableData: [],
				tableLoading: false,
				currentPage: 1,
				pageSize: 10,
				totalCount: 1,
				discardForm: {},
				discardVisible: false,
				discardLoading: false,
				detailShow: false,
				detailId: '',
      }
    },
    methods: {
			getSelectInfo() {
				let url = `${this.$store.state.islhurl}configMain/queryLabelList?`;
				let configKeyList = [
					'majorProjectType',
					'majorProjectCategory',
					'majorProjectLevel',
					'applyStatus',
				]
				let str = '';
				configKeyList.forEach(item => {
					str += `&configKeyList=${item}`;
				})
				url = url + str.substring(1)
				const _this = this
				this._post(url).then(
					res => {
						if (res.data && res.code === 200) {
							Object.keys(res.data).forEach(function(key) {
								_this[key] = res.data[key];
							});
						}
					}
				)
			},
			handleSearch() {
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
					...this.searchForm,
				}
				this.tableLoading = true;
				let url =`${this.$store.state.islhurl}majorProjectFlow/getListByPage/${this.pageSize}/${this.currentPage}`
				this._post(url,params).then(
					res => {
						this.tableLoading = false;
						if(res.code === 200) {
						this.tableData = res.data;
						this.totalCount = res.totalNums;
						} else {
							this.tableData = [];
							this.$message.error(res.message || 'Failed!' );
						}
					}
				)
			},
			changePageSize(size) {
				this.pageSize = size;
				this.handleSearch();
			},
			changePage(current) {
				this.currentPage = current;
				this.handleSearch();
			},
			handleReset() {
				this.searchForm = {};
			},
			handleExport() {
				this.exportLoading = true;
				this.exportLoading = false;
			},
			// openDetail(record) {
			// 	let params = {
			// 		id: record.id,
			// 		page: 'projectApproval'
			// 	}
			// 	this.$router.push({ name:'projectApplication', params });
			// },
			openDetail(record) {
				this.detailShow = true;
				this.detailId = record.majorProjectId;
			},
			closeDetail() {
				this.detailShow = false;
				this.detailId = '';
			},
			openDiscard(record) {
				this.discardVisible = true
				this.discardForm = record
			},
			closeDiscard() {
				this.discardVisible = false
				this.$refs.discardForm.resetFields();
			},
			projectDiscard() {
				this.$refs.discardForm.validate((valid) => {
					if (valid) {
						let params = {
							islhToken : sessionStorage.getItem('islhtoken'),
							reason: this.discardForm.reason,
							id: this.discardForm.id,
							approvalStatus: this.discardForm.approvalStatus,
							majorProjectId:  this.discardForm.majorProjectId,
						}
						this.discardLoading = true;
						let url =`${this.$store.state.islhurl}majorProjectFlow/discard`
						this._post(url,params).then(
							res => {
								if(res.code === 200) {
									this.$Message.success('Successful!');
									this.closeDiscard();
									this.handleSearch();
								} else {
									this.$message.error(res.message || 'Failed!');
								}
								this.discardLoading = false
							}
						)
					} else {
						return false;
					}
				});
			}
		},
  }
</script>
<style lang="less" scoped>
#projectApproval {
	.el-message {
		z-index: 99999;
	}
	.hiddencard {
		height: 0;
		overflow: hidden;
	}
	.el-form {
		padding: 20px 0 20px 0;
		.el-form-item {
			margin-bottom: 10px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 0px;
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
		}
	}
	.el-table {
		/deep/th.el-table__cell>.cell {
			word-break: break-word;
		}
	}
	/deep/.el-table .cell {
		word-break: break-word;
	}
	/deep/.el-dialog__body {
		border-top: 1px solid #e8eaec;
		border-bottom: 1px solid #e8eaec;
		.el-form {
			padding: 0;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/view/major/projectApproval/index.vue